import { getAppConfig, isConsentGranted } from "./global.js";
import logger from "./logger.js";
import { refreshSession } from "./session.js";
import { isBrowser } from "./global.js";
export const getLocation = () => {
    if (!isBrowser())
        return {};
    const { origin, pathname, hash } = new URL(window.location.toString());
    return { origin, pathname, hash };
};
const getReferrer = () => {
    if (!isBrowser())
        return {};
    return { referrer: document.referrer };
};
export const getMeta = () => {
    return {
        ...getLocation(),
        ...getReferrer(),
    };
};
export const trackEvent = async ({ eventName, ...data }) => {
    try {
        const appConfig = getAppConfig();
        const session = isConsentGranted() ? refreshSession() : {};
        const appMeta = appConfig?.attachMeta ? appConfig.attachMeta() : {};
        const payload = {
            ...session,
            ...getMeta(),
            ...appMeta,
            event: eventName,
            ...data,
        };
        await appConfig?.trackEvent(payload, { logger });
    }
    catch (e) {
        logger.error("Event tracking failed!", e);
    }
};
